const addAgreement = r => require.ensure([], () => r(require('./components/add-agreement')), 'adobeAcrobat');
const Details = r => require.ensure([], () => r(require('./components/details')), 'adobeAcrobat');
const adobeAuth = r => require.ensure([], () => r(require('./components/adobe_auth')), 'adobeAcrobat');
const viewFiles = r => require.ensure([], () => r(require('./components/view-agreements')), 'adobeAcrobat');
const agreementDetails = r => require.ensure([], () => r(require('./components/agreement-details')), 'adobeAcrobat');
export default[
	{
		name: 'adobeAuth',
		path: '/adobe-auth',
		component: adobeAuth,
	},
	{
		name: 'addAgreement',
		path: '/add-agreement',
		component: addAgreement,
	},
	{
		name: 'Details',
		path: '/agreement-details',
		component: Details,
	},
	{
		name: 'viewFiles',
		path: '/view-agreements',
		component: viewFiles,
	},
	{
		name: 'agreement.details',
		path: '/agreement/:id/details',
		component: agreementDetails,
	}
]


// WEBPACK FOOTER //
// ./src/app/adobeAcrobat/routes.js